<script setup lang="ts">
import VerticalGap from '@shell/components/Resource/Detail/Card/VerticalGap.vue';

export interface CardProps {
    title?: string;
}

const { title } = defineProps<CardProps>();

</script>

<template>
  <div class="detail-card">
    <div class="heading">
      <slot name="heading">
        <div class="title">
          <slot name="title">
            {{ title }}
          </slot>
        </div>
      </slot>
      <slot name="heading-action" />
    </div>
    <VerticalGap />
    <div class="body">
      <slot name="default" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.detail-card {
    padding: 20px;
    min-width: 0;
    border-radius: 8px;
    border: 1px solid var(--dev-border, var(--border));
    background: var(--dev-surface, var(--body-bg));
    color: var(--dev-ink, var(--body-text));

    .heading {
      display: flex;
      justify-content: space-between;

      min-height: 32px;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;

      .title {
          font-size: 16px;
          font-weight: 600;
          line-height: 1.4;
          overflow-wrap: anywhere;
      }
    }

    .body {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      min-width: 0;
    }
}
</style>
